import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

export type Tutorial = {
  feedTutorial: boolean
  receivedReferralTutorial: boolean
  sendReferralTutorial: boolean
  homeTutorial: boolean
  visibilityTutorial: boolean
}

const getUserTutorials = async (): Promise<Tutorial | undefined> => {
  try {
    const response = await getRequest<Tutorial>('/users/preferences/tutorials')
    if (!response) {
      throw new Error('Post not found')
    }

    return response
  } catch (error) {
    throw new Error(`Failed to fetch post | ${error}`)
  }
}

export function useUserTutorials() {
  return useQuery({
    ...queries.users.me._ctx.tutorials,
    queryFn: getUserTutorials,
  })
}
